import {Component, HostBinding, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { ReportPageInterface } from 'src/app/interface';
import { FooterButtonOption, PageNumbers } from 'src/app/model/Enums';
import { FieldValue } from 'src/app/model/field-value';
import { Ownership } from 'src/app/model/ownership';
import { Report } from 'src/app/model/report';
import { ReportProvider } from 'src/app/providers';
import { ReportService, ToasterService } from 'src/app/services';
import * as _ from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { WizardOwnerSalaryPopupComponent } from '../../../components/wizard-owner-salary-popup/wizard-owner-salary-popup.component';
import { OwnerAssistEntity } from 'src/app/model';
import { ReportPageConstant } from 'src/app/constants/reportPage.constants';
import {routeTransition} from '../../../../../animations/route-transition';

@Component({
  selector: 'app-replacement-salary',
  templateUrl: './replacement-salary.component.html',
  styleUrls: ['./replacement-salary.component.scss'],
  animations: [routeTransition],
})
export class ReplacementSalaryComponent implements OnInit, OnDestroy, ReportPageInterface {
  @HostBinding('@routeTransition') routeAnimation = true;
  public currentReport: Report;
  private reportSub: Subscription;
  reportPageConst = ReportPageConstant;

  ownerList: Ownership[] = [];

  @ViewChild('salaryForm') salaryForm: NgForm;

  constructor(public reportService: ReportService,
    private reportProvider: ReportProvider,
    private modalService: BsModalService,
    private router: Router,
    private toastr: ToasterService) { }

  ngOnInit(): void {
    this.reportSub = this.reportService.report$.subscribe(currentReport => {
      this.currentReport = currentReport;
      if (this.currentReport && this.currentReport.LATEST) {
        if (this.currentReport?.LATEST?.OWNERSHIP_LIST?.length) {
          this.ownerList = _.cloneDeep(this.currentReport.LATEST.OWNERSHIP_LIST);
          this.ownerList.sort((a, b) => Number(a.ORDER) - Number(b.ORDER));
        }
        setTimeout(() => {
          this.checkForWizard(true);
        }, 1);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.currentReport) {
      this.currentReport.LATEST.OWNERSHIP_LIST = this.ownerList;
    }
    if (this.reportSub)
      this.reportSub.unsubscribe();
  }

  /**
   * @description field update API
   * @param fieldName field name which we want to update
   * @param obj seleted owner which owner we want to update
   */
  callUpdateAPI(fieldName: string, obj: Ownership) {

    let objFieldValue = new FieldValue();
    objFieldValue.GROUP = 'OWNERSHIP';
    objFieldValue.FIELD = fieldName;
    objFieldValue.VALUE = obj[fieldName];
    this.reportProvider.updateReportField(obj.ID, objFieldValue).subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description field update API
   * @param fieldName field name which we want to update
   */
  callUpdateReportVersionAPI(fieldName: string) {
    let objFieldValue = new FieldValue();
    objFieldValue.GROUP = 'REPORT_VERSION';
    objFieldValue.FIELD = fieldName;
    objFieldValue.VALUE = this.currentReport.LATEST[fieldName];
    this.reportProvider.updateReportField(this.currentReport.LATEST.ID, objFieldValue).subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description goto ownership page
   */
  gotoOwnership() {
    this.reportService.updateMaxStage(PageNumbers.REPLACEMENT_SALARY);
    this.router.navigateByUrl(`/report/${this.currentReport.ID}/ownership`);
  }

  checkForWizard(fromInit: boolean = false) {
    if (this.ownerList.length === 1 || this.ownerList.reduce((summ, v) => (summ += Number(v.HOURS) || 0), 0) <= 50) {
      this.getFairMarketReplacementSalaryDetails();
    } else {
      if ((fromInit && (this.currentReport.LATEST.ASSISTED_REPLACEMENT_SALARY == null || this.currentReport.LATEST.ASSISTED_REPLACEMENT_SALARY == undefined))
        || (!fromInit && this.currentReport.LATEST.ASSISTED_REPLACEMENT_SALARY)) {
        this.openWizardPopup();
      }
    }
  }

  getFairMarketReplacementSalaryDetails(mainOwnerID: string = '', fieldArray: Array<OwnerAssistEntity> = []) {
    this.reportProvider.getFairMarketReplacementSalary(this.currentReport.LATEST.ID, mainOwnerID, fieldArray).subscribe(response => {
      if (response.success) {
        const result = response.result;
        result.forEach(element => {
          const ownerIndex = this.ownerList.findIndex(x => x.ID === element.ID);
          if (ownerIndex != -1) {
            this.ownerList[ownerIndex][element.FIELD] = element.VALUE;
          }
        });
        if (this.currentReport.LATEST.ASSISTED_REPLACEMENT_SALARY == null || this.currentReport.LATEST.ASSISTED_REPLACEMENT_SALARY == undefined) {
          this.currentReport.LATEST.ASSISTED_REPLACEMENT_SALARY = false;
          this.calculateButtonClick('ASSISTED_REPLACEMENT_SALARY', false);
        }
      } else {
        this.toastr.error(response.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  openWizardPopup() {
    let confirmModalRef: BsModalRef;
    confirmModalRef = this.modalService.show(WizardOwnerSalaryPopupComponent, { class: 'modal-lg modal-dialog-centered' });

    const ackSubject = new Subject<boolean>();
    confirmModalRef.content.subject = ackSubject;

    ackSubject.subscribe(value => {
      if (value) {
        this.getFairMarketReplacementSalaryDetails(value['mainOwnerID'], value['ownerArray']);
      } else {
        if (this.currentReport.LATEST.ASSISTED_REPLACEMENT_SALARY == null || this.currentReport.LATEST.ASSISTED_REPLACEMENT_SALARY == undefined) {
          this.currentReport.LATEST.ASSISTED_REPLACEMENT_SALARY = true;
          this.calculateButtonClick('ASSISTED_REPLACEMENT_SALARY', false);
        }
      }
    });
  }

  calculateButtonClick(fieldName: string, checkWizard: boolean = true) {
    this.currentReport.LATEST.ASSISTED_REPLACEMENT_SALARY = !this.currentReport.LATEST.ASSISTED_REPLACEMENT_SALARY;

    let objFieldValue = new FieldValue();
    objFieldValue.GROUP = 'REPORT_VERSION';
    objFieldValue.FIELD = fieldName;
    objFieldValue.VALUE = this.currentReport.LATEST[fieldName];
    this.reportProvider.updateReportField(this.currentReport.LATEST.ID, objFieldValue).subscribe(res => {
      if (res.success) {
        if (this.currentReport.LATEST.ASSISTED_REPLACEMENT_SALARY && checkWizard) {
          this.checkForWizard();
        }
      } else {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });


  }

  // checkValidation(): boolean {
  //   return !this.ownerList.some(el => !el.ASSISTED_REPLACEMENT_SALARY && Number(el.REPLACEMENT_SALARY) <= 0);
  // }

  /**
   * @description function of interface for validation
   * @returns form valid or not
   */
  isFormValid(): boolean {
    return !this.salaryForm.invalid || this.currentReport?.isLocked;
  }

  /**
   * @description function of interface for skip functionality
   * @returns form can be skippable or not
   */
  canBeSkipped(): boolean {
    return false;
  }

  /**
   * @description report footer button click options
   * @param buttonOption which button clicked by user
   */
  footerButtonClick(buttonOption: number) {
    if (buttonOption == FooterButtonOption.NEXT_CLICK || buttonOption == FooterButtonOption.SKIP_CLICK) {
      this.reportService.updateMaxStage(PageNumbers.REPLACEMENT_SALARY);
      this.router.navigateByUrl(`/report/${this.currentReport.ID}/adjustments`);
    } else if (buttonOption == FooterButtonOption.BACK_CLICK) {
      if (this.reportService.showRentAdjustments()) {
        this.router.navigateByUrl(`/report/${this.currentReport.ID}/rent/rent-details`);
      } else {
        this.router.navigateByUrl(`/report/${this.currentReport.ID}/future-projection`);
      }
    }
  }

}
